import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const featuredArticles = articles.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-2">
              最新<span className="text-primary-500">教程</span>与资讯
            </h2>
            <p className="text-sm text-foreground-500">掌握BaoyuTV最新动态与使用技巧</p>
          </div>
          <Link
            to="/article/baoyutv-xinshourumen"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-3">{article.excerpt}</p>
                <span className="text-xs text-foreground-400">{article.readTime} 阅读</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/article/baoyutv-xinshourumen"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}